<template>
  <footer class="footer">
    <div class="container">
      <div class="copyright text-center">
        {{ $t('footer.copyright', { year: currentYear }) }}
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
};
</script>
<style></style>
